/**
 * 打印逻辑
 * 包括初始化建立、关闭连接、数据打印等
 */
export default {
  data() {
    return {
      // 避免数据污染，建议下划线开头
      _printData: "", // 打印数据
      _isWebsocketOpen: false, // 打印机是否建立连接
    };
  },
  created() {
    this.initWebSocket();
  },
  beforeDestroy() {
    this.closeWebSocket();
  },
  methods: {
    // websocket相关
    initWebSocket() {
      // 初始化websocket
      const wsUri =
        document.location.protocol === "https:"
          ? "wss://localhost:13529"
          : "ws://localhost:13528";
      this.websock = new WebSocket(wsUri);
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      this._isWebsocketOpen = true;
    },
    websocketonerror() {
      // 错误
      this.$alert("打印机连接失败", "提示", {
        confirmButtonText: "知道了",
        center: true,
        type: "error",
        callback: () => {
          this._isWebsocketOpen = false;
        },
      });
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd === "print") {
        if (obj.status === "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "重新打印",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.websocketsend(this._printData);
          });
        } else {
          this.$message.success("打印成功");
        }
      }
    },
    websocketsend(data) {
      // 数据发送
      this.websock.send(data);
    },
    websocketclose() {
      // 关闭
    },
    closeWebSocket() {
      this._isWebsocketOpen = false;
      if (this.websock) {
        this.websock.close();
      }
    },
    doPrint(data) {
      const printData = JSON.stringify(data);
      this.websock.send(printData);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/print.js